import React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers'
import { TextField } from '@mui/material'

export default function index({ SelectedDate, handleDateChange, Lable, name, variant, width, Require, minDate = null, maxDate = null, readOnly }) {
    return (
        <>
            <div className="d-flex flex-column">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        readOnly={readOnly}
                        inputFormat="MM/dd/yyyy"
                        value={SelectedDate}
                        onChange={readOnly ? () => {} : handleDateChange}
                        onBlur={handleDateChange}
                        name={name}
                        label={Lable}
                        minDate={minDate}
                        maxDate={maxDate}
                        renderInput={(params) => <TextField size="small" label={Lable} {...params} sx={{ width: width ? width : '182px' }} />}
                    />
                </LocalizationProvider>
            </div>
        </>
    )
}
